import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { formMappings } from "../../../../config/formMappings";
import { FormEntry } from "../../../../types/types";

interface AverageTablesPerRegistrationProps {
  v2Entries: FormEntry[];
}

export default function AverageTablesPerRegistration({
  v2Entries,
}: AverageTablesPerRegistrationProps) {
  const activeFormName = useSelector(
    (state: RootState) => state.activeForm.activeFormName
  );
  const formMapping = formMappings[activeFormName as keyof typeof formMappings];
  const transportationRequestMapping =
    formMapping && "transportationRequest" in formMapping
      ? formMapping.transportationRequest?.fieldMappings
      : undefined;

  // Filter paid transportation requests
  const paidTransportationRequests = v2Entries.filter((entry) => {
    if (!transportationRequestMapping) return false;

    const paidStatusRaw =
      entry.meta[transportationRequestMapping.paid] ||
      entry.meta["Paid?"] ||
      "No";
    const paidStatus = Array.isArray(paidStatusRaw)
      ? paidStatusRaw[0]
      : paidStatusRaw;
    return paidStatus === "Yes";
  });

  // Calculate total number of people and number of requests
  const { totalPeople, requestCount } = paidTransportationRequests.reduce(
    (acc, entry) => {
      if (!transportationRequestMapping) return acc;

      const numberOfPeopleStr =
        entry.meta[transportationRequestMapping.numberOfPeople] || "0";
      const numberOfPeople = parseInt(
        Array.isArray(numberOfPeopleStr)
          ? numberOfPeopleStr[0]
          : numberOfPeopleStr,
        10
      );

      return {
        totalPeople:
          acc.totalPeople + (isNaN(numberOfPeople) ? 0 : numberOfPeople),
        requestCount: acc.requestCount + 1,
      };
    },
    { totalPeople: 0, requestCount: 0 }
  );

  // Calculate average
  const average = requestCount > 0 ? totalPeople / requestCount : 0;

  return (
    <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
      <dt className="truncate text-sm font-medium text-gray-500">
        Average Registrants Needing Ride
      </dt>
      <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
        {average.toFixed(2)}
      </dd>
    </div>
  );
}
